import React, { useContext, useEffect, useRef, useState } from "react";
import "./home.css";
import "./step.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Modal from "../Modal/Modal";
import OverLayButton from "../Other/OverLayButton";
import { FaListAlt, FaMap, FaRegListAlt, FaRegMap } from "react-icons/fa";
import { GlobalContext } from "../../GlobalProvider";
import LoadingBar from "../common/Loader/LoadingBar";
import { IoIosArrowBack } from "react-icons/io";

import FilledStar from '../commonAssests/FilledStar.svg'
import CircularCheck from '../commonAssests/CircularCheck.svg'
import { closeIcon, directionIcon, getCustomMarker, getStar, phoneIcon } from "../../utils/commanFunctions";
import { Header } from "../common/Header";
import { ViewButton } from "../common/Buttons/ViewButton";
import configs from "../../contentConfig";
import { BOTTOM_NAV_ICONS } from "../../icons/BottomNavIcons";
import { runAction, hrefForAction } from "../../utils/actions";

const bottomNavItems = configs?.bottomNav?.items || [];

const Home = (props) => {
  const {showBottomNav=true, showPersonalizedButton=true, showOldFilter=true , isLoading=true,showFloatButton=false,floatBottonData={}} = props
  const navigate = useNavigate();
  const location = useLocation();
  const {personalizedB,setPersonalizedB,filter,handleFilter,filterLoading,setFilterLoading,hotelData} = useContext(GlobalContext)
  const personalizedModal = useRef()
  const handleModel = (e)=>{
    e?.stopPropagation()
    setPersonalizedB((p) => !p);
    console.log(personalizedB)
}


 const getPathFromHash = () => {
  const cleanedHash = window.location.hash.replace(/^#\/?/, "");
  const searchParams = new URLSearchParams(cleanedHash);
  return searchParams.get("path");
};

useEffect(() => {
  const currentTab = localStorage.getItem("selectedTab");

  if (!currentTab) {
    const path = getPathFromHash();

    let defaultTab = "Explore";

    if (path === "hotel") defaultTab = "Hotel";

    localStorage.setItem("selectedTab", defaultTab);
  }
}, []);




const handlefiler = (type,page)=>{
if(filter !== type){
  let timout = null
  if(type === "Personalized"){
    timout = 1500
  }else{
    if(props.setPageForSmall)
    props.setPageForSmall(2)
    if(props.setPageForLarge)
    props.setPageForLarge(2)
  }
  if(props.largeRef)
  props.largeRef.current.scrollTop = 0
  if(props.smallRef)
  props.smallRef.current.scrollLeft = 0
  setFilterLoading(true)
if(timout)
setTimeout(()=>{
  setFilterLoading(false)
},[timout])
  handleFilter(type,setFilterLoading,props.createHotelDetails,props.hotelData,page)
}
  }
  // const [isChatOpen, setIsChatOpen] = useState(false)

  // const toggleChat = () => {
  //   setIsChatOpen(!isChatOpen)
  // }

  return (
    <div className={`home relative ${props?.nav ? `route-${props.nav.toLowerCase()}` : ""}`}>
      {/* <button onClick={()=> {toggleChat()}} className="chat-bot-button absolute bottom-[400px] right-6 z-50 bg-red-500">Hello</button>
      {isChatOpen && <InnspireChatInitialize/>} */}
        {/* <div className="absolute top-[30%] left-[40%] max-w-[70vw] md:max-w-[50vw] lg:max-w-[25vw] z-50 shadow-2xl border rounded-2xl overflow-hidden">
        <img src={closeIcon()} alt="" className="absolute top-[10px] right-[10px] w-[20px]"/>
      <div class="imgage">
        <img
          class="w-[100%] max-h-[20vh]"
          src="https://img2.10bestmedia.com/Images/Photos/393473/Aerial-1_55_660x440.jpg"
          alt=""
        />
      </div>
      <div class="content bg-white w-[100%] p-3 md:p-5">
        <div class="one w-[100%]  flex items-start justify-between">
       <span className="text-md md:text-1xl max-w-[75%] font-bold mb-4"> San Francisco Museum of Modern Art</span>
       <div className="buttons flex items-center justify-center gap-4">
        <span>
          <img src={directionIcon()} alt="" className="w-[20px]"/>
        </span>
        <span>
        <img src={phoneIcon()} alt="" className="w-[18px]"/>
        </span>
       </div>
        </div>

       <div class="three mb-2">
          <p class="text-md md:text-lg font-medium">24 Willie Mays Plaza, San Francisco, CA 94107, USA</p>
        </div> 



        <div className="mb-2 flex items-center justify-start gap-3">
    <div className="flex items-center justify-start gap-1">
    <span className="text-gray-600 font-medium text-sm md:text-md">4.5</span> 
        <div className="flex items-center justify-center gap-1">
        <img src={getStar("full")} alt="" className="w-[15px]"/>
        <img src={getStar("full")} alt="" className="w-[15px]"/>
        <img src={getStar("full")} alt="" className="w-[15px]"/>
        <img src={getStar("full")} alt="" className="w-[15px]"/>
        <img src={getStar("full")} alt="" className="w-[15px]"/>
        </div>
    </div>
        <span className="text-gray-600 font-medium text-sm md:text-lg">(45)</span>
        <div className="flex items-center justify-center gap-1">
          <img src={getCustomMarker("green")} alt="" className="w-[13px]" />
          <span className="text-gray-600 font-medium text-sm md:text-lg">30000 mi</span>
        </div>
        </div>

        <div class="two flex items-center justify-start gap-2 flex-wrap">
            <div className="flex items-center justify-start gap-1">
                  <img src={CircularCheck} alt="" />
                  <span class="text-gray-600 font-medium text-sm md:text-md">Entertainment</span>
            </div>
            <div className="flex items-center justify-start gap-1">
                  <img src={CircularCheck} alt="" />
                  <span class="text-gray-600 font-medium text-sm md:text-md">Food</span>
            </div>
            <div className="flex items-center justify-start gap-1">
                  <img src={CircularCheck} alt="" />
                  <span class="text-gray-600 font-medium text-sm md:text-md">Refreshment</span>
            </div>
         
        </div>
       
    </div>
      </div> */}
  

      {/* Back button======================== */}
      {props.nav === "Description" && (
        <div
          onClick={() => {
            navigate(-1);
          }}
          className="absolute top-[-1%] left-[4%] p-2 md:p-1 z-10 rounded-xl cursor-pointer hover:opacity-[0.7]"
          style={{
            background:localStorage.getItem("primaryColor") ? "#" + localStorage.getItem("primaryColor"): "#080808",
          }}
        >
          <IoIosArrowBack className="text-sm md:text-sm text-white" />
        </div>
      )}
      {/* Back button======================== */}

      {/* Filter=======================  */}
      {showOldFilter && !personalizedB && props.nav === "Map" && (
        <div className="filter flex items-center gap-3 justify-center absolute top-[3%] left-[50%] transform translate-x-[-50%] z-50 cursor-pointer">
          <span
            className="shadow-2xl  p-[1vh] md:py-1 md:px-2 text-sm md:text-md min-w-[5%]"
            // rounded-md
            style={{
              background:
                filter === "Personalized"
                  ?  localStorage.getItem("primaryColor") ? "#" + localStorage.getItem("primaryColor") : "#080808"
                  : "white",
              color: filter === "Personalized" ? "white" : "black",
              border: `1px solid`,
              textAlign: "center",
            }}
            onClick={() => {
              handlefiler("Personalized",props.nav);
            }}
          >
            Personalized
          </span>
          <span
            className="shadow-2xl  p-[1vh] md:py-1 md:px-2 text-sm md:text-md min-w-[5%] cursor-pointer"
            // rounded-md
            style={{
              background:
                filter === "all"
                  ?  localStorage.getItem("primaryColor") ? "#" + localStorage.getItem("primaryColor"): "#080808"
                  : "white",
              color: filter === "all" ? "white" : "black",
              border: `1px solid`,
              textAlign: "center",
            }}
            onClick={() => {
              handlefiler("all",props.nav);
            }}
          >
            All
          </span>
        </div>
      )}


      {props.children}

     {
      // Bottom Navigation — config-driven
      showBottomNav &&  !["Description"].includes(props.nav) &&
        <div className="navContainer  w-[100vw]  bottom-[0%] ">
      <div
        className={`mainBox flex items-center md:justify-center justify-around h-[10vh]`}
        style={{
          background:localStorage.getItem("primaryColor") ? "#" + localStorage.getItem("primaryColor"): "#080808",
        }}
      >
        {bottomNavItems.map((item) => {
          const Icon = BOTTOM_NAV_ICONS[item.icon];
          const currentPath = new URLSearchParams(location.search).get("path");
          const isActive = item.action?.type === "navigate" && item.action.path === currentPath;
          const iconClass = isActive ? "bottom-nav-icon-active" : "bottom-nav-icon";
          const textClass = isActive ? "bottom-nav-text-active" : "bottom-nav-text";
          const href = hrefForAction(item.action);
          const handleClick = () => localStorage.setItem("selectedTab", item.label);

          const content = (
            <div className="hotel flex flex-col w-30 md:min-w-[135px] justify-center mt-1 items-center py-1 md:pb-3 md:pt-4 hover:opacity-[0.7] cursor-pointer">
              {Icon && <Icon className={iconClass} />}
              <p className={`p-1 text-[12px] ${textClass} text-gray-300`}>{item.label}</p>
            </div>
          );

          if (href) {
            return (
              <Link key={item.id} to={href} onClick={handleClick}>
                {content}
              </Link>
            );
          }
          return (
            <div key={item.id} onClick={() => { handleClick(); runAction(item.action, navigate); }}>
              {content}
            </div>
          );
        })}
        <span className="absolute bottom-[7vh] text-white text-[1.5vmax] lg:text-[0.7vmax] app-version">{process.env.REACT_APP_VERSION}</span>
      </div>
    </div>
     }

      <Modal
        handleModel={handleModel}
        personalizedB={personalizedB}
        personalizedModal={personalizedModal}
        nav={props.nav}
      />

      {showPersonalizedButton &&  props.nav === "List" && (
        <OverLayButton
          color={localStorage.getItem("primaryColor") ? "#" + localStorage.getItem("primaryColor"): "#080808"}
          handleModel={handleModel}
          personalizedB={personalizedB}
        />
      )}

      {/* // overLay Component */}
      {filterLoading && (
        <div className="w-[100vw] h-[100vh] bg-[#030712] z-50 absolute top-[0] opacity-[0.5] flex items-center justify-center">
          <LoadingBar width="80vw" color="green" />
        </div>
      )}

{
  showFloatButton  && !isLoading &&   <div className={`w-full flex justify-center align-center ${floatBottonData.parentCss} z-10`}>
  <ViewButton
       className="floating-view-button"
       variant={floatBottonData.variant}
       url={floatBottonData.url}
     />
  </div>
 }
    </div>
  );
};

export default Home;
